import React from "react";
import { Link } from "react-router-dom";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";
import SuperPopin from "./SuperPopin";
import UserHelpDocument from "./UserHelpDocument";

const FOOTER_PAGES = [
  { code: "legal_mentions", labelKey: "footer.links.legal_mentions" },
  { code: "terms_of_use", labelKey: "footer.links.terms_of_use" },
];

function Footer({ t }: WithTranslation) {
  const year = new Date().getFullYear();
  const [helpShown, setHelpShown] = React.useState(false);

  return (
    <footer className="Footer" aria-label={t("footer.aria_label")}>
      <div className="Footer-inner">
        <div className="Footer-brand">
          <span className="Footer-kicker">{t("topbar.platform_label")}</span>
          <span className="Footer-copy">{t("footer.copyright", { year })}</span>
        </div>
        <nav className="Footer-links" aria-label={t("footer.links_aria_label")}>
          <button type="button" className="Footer-link" onClick={() => setHelpShown(true)}>
            {t("footer.links.help")}
          </button>
          {FOOTER_PAGES.map((page) => (
            <Link key={page.code} to={BASE_PATH + "/page/" + page.code} className="Footer-link">
              {t(page.labelKey)}
            </Link>
          ))}
        </nav>
      </div>
      <SuperPopin
        shown={helpShown}
        closePopin={() => setHelpShown(false)}
        additionalClasses={["DocumentPreviewPopin", "isBig"]}
      >
        {helpShown ? <UserHelpDocument /> : null}
      </SuperPopin>
    </footer>
  );
}

export default compose(withTranslation())(Footer);
